import requests from "../util";
import { UserExcursion } from "./type";

const url = "user-excursion";

const userExcursionApi = {
  createUserExcursion: (
    userExcursion: Partial<UserExcursion>
  ): Promise<UserExcursion> => requests.post(url, userExcursion),
  getUserExcursionsFromUserId: (userId: string) =>
    requests.get(`${url}?userId=${userId}`),
  
  getUserExcursionsFromStoreId: (storeId: string) =>
    requests.get(`${url}/store/${storeId}`),
};

export default userExcursionApi;
